{
   "name": "matchpoint-showcase",
   "version": "0.0.0",
   "scripts": {
      "start": "env NG_BUILD_MANGLE=false ng serve --open",
      "build": "env NG_BUILD_MANGLE=false ng build --output-hashing=all --base-href=/",
      "build:staging": "env NG_BUILD_MANGLE=false ng build --configuration staging --output-hashing=all --base-href=/",
      "build:prod": "env NG_BUILD_MANGLE=false ng build --configuration production --output-hashing=all --base-href=/",
      "format-code": "prettier --write .",
      "format-code:check": "prettier --check .",
      "prepare": "husky"
   },
   "lint-staged": {
      "**/*": "prettier --write --ignore-unknown"
   },
   "private": true,
   "dependencies": {
      "@angular/animations": "19.1.6",
      "@angular/cdk": "19.2.18",
      "@angular/common": "19.1.6",
      "@angular/compiler": "19.1.6",
      "@angular/core": "19.1.6",
      "@angular/elements": "19.1.6",
      "@angular/forms": "19.1.6",
      "@angular/platform-browser": "19.1.6",
      "@angular/platform-browser-dynamic": "19.1.6",
      "@angular/router": "19.1.6",
      "@ngrx/effects": "^19.0.0",
      "@ngrx/router-store": "^19.0.0",
      "@ngrx/store": "^19.0.0",
      "@ngx-translate/core": "^15.0.0",
      "@ngx-translate/http-loader": "^8.0.0",
      "@primeng/themes": "^19.0.6",
      "angular2-notifications": "^16.0.1",
      "ng-inline-svg-2": "^15.0.1",
      "primeicons": "^7.0.0",
      "primeng": "^19.0.5",
      "rxjs": "~7.8.1",
      "tslib": "^2.6.3",
      "zone.js": "~0.15.1",
      "keycloak-angular": "^19.0.0",
      "keycloak-js": "^26.0.0"
   },
   "devDependencies": {
      "@angular-devkit/build-angular": "19.1.6",
      "@angular/cli": "19.1.6",
      "@angular/compiler-cli": "19.1.6",
      "@ngrx/store-devtools": "^19.0.0",
      "@types/jasmine": "~5.1.0",
      "@types/keycloak-js": "^3.4.1",
      "autoprefixer": "^10.4.19",
      "husky": "^9.0.11",
      "jasmine-core": "~5.1.0",
      "karma": "~6.4.0",
      "karma-chrome-launcher": "~3.2.0",
      "karma-coverage": "~2.2.0",
      "karma-jasmine": "~5.1.0",
      "karma-jasmine-html-reporter": "~2.1.0",
      "lint-staged": "^15.2.7",
      "postcss": "^8.4.38",
      "prettier": "^3.3.2",
      "tailwindcss": "^3.4.4",
      "typescript": "~5.5.2"
   }
}
